import $ from 'jquery';
import imagePath from '@images/spinner.gif';

export default function personModal() {
  const $modal = $('#person-modal');
  if (!$modal.length) return;

  const $body = $modal.find('.person-modal-body');
  const cache = {};

  if (!$modal.data('zfPlugin')) {
    $modal.foundation();
  }

  $(document).on('click', '.naf-people-link', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!window.wpData?.ajaxUrl) return;

    e.preventDefault();

    const $link = $(this);
    const postId = $link.data('person-id');
    if (!postId) {
      window.location.href = $link.attr('href');
      return;
    }

    const plugin = $modal.data('zfPlugin');
    if (plugin) {
      plugin.$anchor = $link;
    }

    if (cache[postId]) {
      $body.html(cache[postId]);
      $modal.foundation('open');
      return;
    }

    $body.html(
      `<div class="person-modal-loading"><img src="${imagePath}" alt="" width="40" height="40"></div>`
    );
    $modal.foundation('open');

    fetch(window.wpData.ajaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'naf_get_person_bio',
        post_id: postId,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success && result.data.html) {
          cache[postId] = result.data.html;
          $body.html(result.data.html);
        } else {
          window.location.href = $link.attr('href');
        }
      })
      .catch(() => {
        window.location.href = $link.attr('href');
      });
  });
}
